import type { AdvAction } from '~/types/adv';

export const useAdvStat = () => useState('useAdvStat', () => <AdvAction[]>[]) 

